export interface TipContent {
  title: string;
  content: string; // HTML string
}

export const tipsConfig:Record<string, TipContent> = {
  createPrompt: {
    title: 'Tips for designing prompts',
    content: `
      <p>To get the most accurate and reliable results when running prompts on your uploaded documents, follow these guidelines:</p>
      <ul>
        <li><strong>Keep it focused:</strong> Aim for clarity by structuring your prompt around a main objective. If including multiple related questions, group them logically (e.g., using numbered lists) to help the AI maintain focus and deliver precise responses. Overloading with unrelated queries can reduce accuracy, so consider separate prompts for distinct topics.</li>
        <li><strong>Be clear and specific:</strong> Use precise language to describe what you're asking. For example, instead of a vague prompt like "Tell me everything about this document," try "Summarize the key diagnostic findings and treatment recommendations from the patient's history section."</li>
        <li><strong>Break down complex queries:</strong> If you have several related questions, create separate prompts for each. This improves accuracy and makes it easier to manage and refine your results.</li>
        <li><strong>Test and iterate:</strong> Start with simple prompts and build from there. Review the outputs and adjust as needed for better performance.</li>
      </ul>
    `,
  },
  createInterimInvoice: {
    title: 'Interim Invoice creation',
    content: `
      <p>An <strong>interim invoice</strong> is a manually generated invoice for the current, ongoing billing period. Normally, invoices are created automatically at the end of each billing cycle. However, if a case is settled before the period ends and an invoice needs to be issued earlier, you can create it manually using the "<strong>Create Interim Invoice</strong>" function.</p>
      <p>To create an interim invoice:</p>
      <ol>
        <li>Open the dialog by clicking the "Create Interim Invoice" button.</li>
        <li>In the dialog, select the specific case for which the interim invoice should be generated.</li>
        <li>Ensure that there are non-zero billable amounts recorded for the selected case within the current billing period (typically one month).</li>
        <li>Click the "Create" button to generate the invoice.</li>
      </ol>
    `,
  },
};
